var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtNodeRail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#E5F6FF",
    stroke: "#1276D3",
    strokeDasharray: "1 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.98333H9.8L10.4 2.56667C10.5 2.28333 10.9 2 11.3 2H14.7C15.1 2 15.5 2.28333 15.6 2.56667L16.2 3.98333H18C19.3 3.98333 20.4 4.83333 20.4 5.77778V15.7889C20.4 16.7333 19.6 17.3944 18.5 17.5833V18.3389L22 22.0222H20L19.5 21.55H6.5L6 22.0222H4L7.5 18.3389V17.5833C6.4 17.3944 5.6 16.7333 5.6 15.7889V5.77778C5.6 4.83333 6.7 3.98333 8 3.98333ZM9.9 17.5833H16.1V18.2444H9.9V17.5833ZM13 2.56667C13.4 2.56667 13.8 2.94444 13.8 3.32222C13.8 3.79444 13.4 4.07778 13 4.07778C12.6 4.07778 12.2 3.79444 12.2 3.32222C12.2 2.94444 12.6 2.56667 13 2.56667ZM16.6 4.73889H9.4C9.2 5.02222 9.3 5.4 9.8 5.4H16.2C16.7 5.4 16.8 5.02222 16.6 4.73889ZM8.4 13.8056C9.2 13.8056 9.8 14.3722 9.8 15.1278C9.8 15.8833 9.2 16.45 8.4 16.45C7.6 16.45 7 15.8833 7 15.1278C7 14.3722 7.6 13.8056 8.4 13.8056ZM17.6 13.8056C18.4 13.8056 19 14.3722 19 15.1278C19 15.8833 18.4 16.45 17.6 16.45C16.8 16.45 16.2 15.8833 16.2 15.1278C16.2 14.3722 16.8 13.8056 17.6 13.8056ZM18.5 20.4167L17.4 19.2833H8.6L7.5 20.4167H18.5ZM7.4 5.96667H18.6C19 5.96667 19.3 6.25 19.3 6.53333V10.1222C19.3 10.4056 19 10.6889 18.6 10.6889H7.4C7 10.6889 6.7 10.4056 6.7 10.1222V6.53333C6.7 6.25 7 5.96667 7.4 5.96667Z",
    fill: "#1192E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtNodeRail);
export default __webpack_public_path__ + "static/media/AtNodeRail.a43e4f59e57d8c895190dbcf27efd394.svg";
export { ForwardRef as ReactComponent };